<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Comprobantes</h3>
      </div>
      <div class="layout__controls">
        <div class="card">
          <div class="card__content">
            <form :action="action" method="POST" enctype="multipart/form-data">
              <input type="hidden" name="_token" :value="token">
              <div class="form-inline">
                <label for="importacion">Importación</label>
                  <div class="form-field">
                    <input type="file" name="importacion" id="importacion" >
                  </div>
                <button v-show="!subidaClickada" @click="clickSubir" type="submit" class="btn-success"><i class="fa fa-upload"></i></button>
                <label><strong>Filtrar por:</strong></label>
                <label>
                  <input type="radio" id="todasFechas" v-model="form.tipoFechaComprobante" value="T"> <span>Todas las fechas</span>
                </label>
                <label>
                  <input type="radio" id="tipoFechaComprobante" v-model="form.tipoFechaComprobante" value="E"> <span>Fecha de emisión</span>
                </label>
                <label>
                  <input type="radio" id="tipoFechaComprobanteA" v-model="form.tipoFechaComprobante" value="A"> <span>Fecha de autorización</span>
                </label>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <k-table @verRide="verRide" tipoFecha="A" :params="form"  @verComprobante="verComprobante" ref="comprobantes"  @descargarComprobante="descargarComprobante" buscarNumero :createButton="false" :editButton="false" 
    :columns="[
      {
        display : 'Tipo de comprobante',
        value : 'descripcion_tipo_comprobante'
      },
      {
        display : 'Nombre/Razón social',
        value : 'razon_social'
      },
      {
        display : 'Nombre comercial',
        value : 'nombre_comercial'
      },
      {
        display : 'Ruc',
        value : 'ruc'
      },
      {
        display : 'Dirección',
        value : 'direccion_matriz'
      },
      {
        display : 'Fecha de emisión',
        value : 'fecha_emision'
      },
      {
        display  : 'Total sin imp.',
        value : 'total_sin_impuestos'
      },
      {
        display : 'Total',
        value : 'total'
      }
    ]"
    fechas 
    :buttons="[
      {
        icon: 'fa-edit',
        class: 'btn-info',
        event: 'verComprobante',
        text: ''
      },
      {
        icon: 'fa-download',
        class: 'btn-success',
        event: 'descargarComprobante',
        text: ''
      },
      {
        icon: 'fa-eye',
        class: 'btn-secondary',
        event: 'verRide',
        text: ''
      }
    ]"
    :path="path" :filterStatus="false" :deleteButton="false">
    </k-table>
  </div>
</template>

<script>
export default {
  props : {
    token : {
      type : String,
      required : true
    }
  },
    data : function () {
        return {
            subidaClickada: false,
            path : url + '/my-bill-bot/consultar',
            form : {
                tipoFechaComprobante : 'T'
            },
            url : url,
            action : url + '/my-bill-bot/importar'
        };
    },
    methods : {
        clickSubir: function () {
          this.subidaClickada = true;
        },
        descargarComprobante : function (comprobante) {
            window.open(this.url + '/storage/' + comprobante.url_xml, '_blank');
        },
        verComprobante : function (comprobante) {
            window.open(this.url + '/compras/' + comprobante.id_comprobante + '/edit', '_blank');
        },
        verRide : function (comprobante) {
          window.open(this.url + '/compras/' + comprobante.id_comprobante + '/ride', '_blank');
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/compras/MyBillBot.vue